import request from '@utils/request';

export async function getJobDetail(params) {
  try {
    const res = await request.post(`/api/official/mobile/job/getJobDetail`, params);
    return res;
  } catch (e) {
    return {};
  }
}

export async function getDeliveryStatus(params) {
  try {
    const res = await request.post(`/api/official/mobile/apply/job/deliveryStatus`, params);
    return res;
  } catch (e) {
    return {};
  }
}
